export const ROW_ANIMATION_DURATION_MS = 300;
export const MAX_WAVE_DELAY_MS = 300;
export const ENTER_OFFSET_PX = 16;
export const EXIT_OFFSET_PX = 120;
export const WAVE_STEP_MS = 50;
export const WAVE_DISTANCE_EXPONENT = 1.15;
